'use client'
import useGetProducts from '@/hooks/product/use-get-products'
import { ProductResponse } from '@/types/product'
import ProductItem from '../common/product-item'

export default function Products() {
  const { data, isLoading, isFetching, error } = useGetProducts({})

  // Chỉ hiển thị loading skeleton khi thực sự loading lần đầu, không có data cache
  if (isLoading && !data) {
    return (
      <div className="bg-white w-full max-w-[1440px] mx-auto p-4 sm:p-6 lg:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden border border-gray-100 p-0 animate-pulse">
              <div className="bg-gray-100 aspect-square w-full mb-4"></div>
              <div className="p-4 space-y-3">
                <div className="h-3 bg-gray-100 rounded w-1/3"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-100 rounded"></div>
                  <div className="h-4 bg-gray-100 rounded w-5/6"></div>
                </div>
                <div className="pt-2">
                  <div className="h-6 bg-gray-100 rounded w-1/2"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-white w-full max-w-[1440px] mx-auto p-4 sm:p-6 lg:p-8">
        <div className="text-center py-20 bg-red-50 rounded-3xl border border-red-100">
          <p className="text-red-600 text-xl font-bold">Có lỗi xảy ra khi tải sản phẩm</p>
          <p className="text-gray-600 mt-2 font-medium text-sm">Vui lòng thử lại sau hoặc làm mới trang</p>
        </div>
      </div>
    )
  }

  if (!data?.items || data.items.length === 0) {
    return (
      <div className="bg-white w-full max-w-[1440px] mx-auto p-4 sm:p-6 lg:p-8">
        <div className="text-center py-20 bg-gray-50 rounded-3xl border border-gray-100">
          <p className="text-gray-600 text-xl font-bold">Không có sản phẩm nào</p>
          <p className="text-gray-400 mt-2 text-sm">Chúng tôi sẽ sớm cập nhật sản phẩm mới</p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white w-full max-w-[1440px] mx-auto p-4 sm:p-6 lg:p-8">
      <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-2xl font-black text-gray-900 tracking-tight">Sản phẩm nổi bật</h2>
          <p className="text-gray-500 text-sm mt-1 font-medium italic">
            Khám phá các sản phẩm chất lượng nhất từ {data.items[0]?.brandName || 'đối tác của chúng tôi'}
          </p>
        </div>
        <div className="flex items-center gap-4">
          <div className="bg-gray-50 px-4 py-2 rounded-xl border border-gray-100 text-xs font-bold text-gray-500 uppercase tracking-wider">
            {data.totalCount} sản phẩm
          </div>
          {isFetching && (
            <div className="flex items-center gap-2 text-blue-600 text-sm font-bold animate-in fade-in slide-in-from-right-4">
              <div className="animate-spin w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full"></div>
              <span>Đang làm mới...</span>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {data.items.map((product: ProductResponse) => (
          <ProductItem key={product.id} data={product} />
        ))}
      </div>
    </div>
  )
}
